import { jsx as _jsx } from "react/jsx-runtime";
import { CheckboxControlled } from '@kubit/web-ui-components/checkbox';
export const SelectorRowCheckbox = ({ variant, checked, checkboxConfig, disabled, onCheckboxChange, }) => {
    return (_jsx(CheckboxControlled, { ...checkboxConfig, checked: checked, disabled: disabled, variant: variant, onChange: () => onCheckboxChange(!checked) }));
};
//# sourceMappingURL=selectorRowCheckbox.js.map